import { render, staticRenderFns } from "./SupplementReviewList.vue?vue&type=template&id=0b239831&scoped=true&"
import script from "./SupplementReviewList.vue?vue&type=script&lang=js&"
export * from "./SupplementReviewList.vue?vue&type=script&lang=js&"
import style0 from "./SupplementReviewList.vue?vue&type=style&index=0&id=0b239831&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b239831",
  null
  
)

export default component.exports